import { FC } from 'react';
import Modal from '@/components/modal';

import PlaneGIF from '@/assets/modal/plane.gif';

interface ISuccessModal {
  isOpen: boolean;
  setIsOpen: (state: boolean) => void;
}

const SuccessModal: FC<ISuccessModal> = ({ isOpen, setIsOpen }) => {
  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <Modal open={isOpen} onClose={onClose} className={'bg-[#192c46] p-6'}>
      <div className="flex flex-col gap-20">
        <h3 className="text-3xl font-jostMedium text-center">
          Perfekt, invitation sendt!
          <hr className="w-[75%] mx-auto mt-2 border-t border-[#BDE0F5]" />
        </h3>
        <div className="flex justify-center">
          <img src={PlaneGIF} alt="success" className="w-[100px] h-[100px]" />
        </div>
        <div className="mt-6 text-center">
          <button
            type="button"
            className="w-[201px] h-[40px] border border-[#BDE0F5] text-[#BDE0F5] text-base font-jostSemiBold cursor-pointer rounded-full bg-transparent hover:bg-white hover:text-[#192c46] transition"
            onClick={onClose}>
            Luk
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default SuccessModal;
